import { render, staticRenderFns } from "./HistoryDataCleansing.vue?vue&type=template&id=4aba012f"
import script from "./HistoryDataCleansing.vue?vue&type=script&lang=js"
export * from "./HistoryDataCleansing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports